export function localDateKey (date = new Date()) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export function configuredWaterYearForDate (omsettings, date = new Date()) {
  const today = localDateKey(date)

  const setting = Object.values(omsettings || {}).find((item) => {
    return item &&
      item.year !== null &&
      item.year !== undefined &&
      item.water_year_start &&
      item.water_year_end &&
      item.water_year_start <= today &&
      item.water_year_end >= today
  })

  return setting ? setting.year : null
}

export function shouldHydrateCachedValue ({ online, currentValue }) {
  if (!online) {
    return true
  }

  if (Array.isArray(currentValue)) {
    return currentValue.length === 0
  }

  if (currentValue && typeof currentValue === 'object') {
    return Object.keys(currentValue).length === 0
  }

  return currentValue === null || currentValue === undefined || currentValue === ''
}
